/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Food Security Exchange API
 * REST API for the FSE platform. Endpoints by BRS module (PLAN.md §5).
 * OpenAPI spec version: 0.0.1
 */
import {
  useMutation
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult
} from '@tanstack/react-query';

import type {
  AuthTokens,
  ClaimRequest,
  LoginRequest,
  OtpRequestRequest,
  OtpRequestResponse,
  OtpVerifyRequest,
  OtpVerifyResponse,
  RefreshRequest,
  ResetPinRequest,
  SignupRequest
} from '.././models';

import { fseAxios } from '../../client';




/**
 * @summary Phone + PIN login
 */
export const authControllerLogin = (
    loginRequest: LoginRequest,
 signal?: AbortSignal
) => {
      
      
      return fseAxios<AuthTokens>(
      {url: `/auth/login`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: loginRequest, signal
    },
      );
    }
  


export const getAuthControllerLoginMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authControllerLogin>>, TError,{data: LoginRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof authControllerLogin>>, TError,{data: LoginRequest}, TContext> => {

const mutationKey = ['authControllerLogin'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof authControllerLogin>>, {data: LoginRequest}> = (props) => {
          const {data} = props ?? {};

          return  authControllerLogin(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AuthControllerLoginMutationResult = NonNullable<Awaited<ReturnType<typeof authControllerLogin>>>
    export type AuthControllerLoginMutationBody = LoginRequest
    export type AuthControllerLoginMutationError = void

    /**
 * @summary Phone + PIN login
 */
export const useAuthControllerLogin = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authControllerLogin>>, TError,{data: LoginRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof authControllerLogin>>,
        TError,
        {data: LoginRequest},
        TContext
      > => {

      const mutationOptions = getAuthControllerLoginMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Rotate refresh + access tokens
 */
export const authControllerRefresh = (
    refreshRequest: RefreshRequest,
 signal?: AbortSignal
) => {
      
      
      return fseAxios<AuthTokens>(
      {url: `/auth/refresh`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: refreshRequest, signal
    },
      );
    }
  


export const getAuthControllerRefreshMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authControllerRefresh>>, TError,{data: RefreshRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof authControllerRefresh>>, TError,{data: RefreshRequest}, TContext> => {

const mutationKey = ['authControllerRefresh'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof authControllerRefresh>>, {data: RefreshRequest}> = (props) => {
          const {data} = props ?? {};

          return  authControllerRefresh(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AuthControllerRefreshMutationResult = NonNullable<Awaited<ReturnType<typeof authControllerRefresh>>>
    export type AuthControllerRefreshMutationBody = RefreshRequest
    export type AuthControllerRefreshMutationError = void

    /**
 * @summary Rotate refresh + access tokens
 */
export const useAuthControllerRefresh = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authControllerRefresh>>, TError,{data: RefreshRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof authControllerRefresh>>,
        TError,
        {data: RefreshRequest},
        TContext
      > => {

      const mutationOptions = getAuthControllerRefreshMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Request a 5-digit OTP via SMS. Code is bcrypt-hashed server-side; 5-minute expiry.
 */
export const authControllerRequestOtp = (
    otpRequestRequest: OtpRequestRequest,
 signal?: AbortSignal
) => {
      
      
      return fseAxios<OtpRequestResponse>(
      {url: `/auth/otp/request`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: otpRequestRequest, signal
    },
      );
    }
  


export const getAuthControllerRequestOtpMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authControllerRequestOtp>>, TError,{data: OtpRequestRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof authControllerRequestOtp>>, TError,{data: OtpRequestRequest}, TContext> => {

const mutationKey = ['authControllerRequestOtp'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof authControllerRequestOtp>>, {data: OtpRequestRequest}> = (props) => {
          const {data} = props ?? {};

          return  authControllerRequestOtp(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AuthControllerRequestOtpMutationResult = NonNullable<Awaited<ReturnType<typeof authControllerRequestOtp>>>
    export type AuthControllerRequestOtpMutationBody = OtpRequestRequest
    export type AuthControllerRequestOtpMutationError = unknown

    /**
 * @summary Request a 5-digit OTP via SMS. Code is bcrypt-hashed server-side; 5-minute expiry.
 */
export const useAuthControllerRequestOtp = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authControllerRequestOtp>>, TError,{data: OtpRequestRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof authControllerRequestOtp>>,
        TError,
        {data: OtpRequestRequest},
        TContext
      > => {

      const mutationOptions = getAuthControllerRequestOtpMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Verify the 5-digit OTP. Marks the row verified; signup must run within 10 minutes.
 */
export const authControllerVerifyOtp = (
    otpVerifyRequest: OtpVerifyRequest,
 signal?: AbortSignal
) => {
      
      
      return fseAxios<OtpVerifyResponse>(
      {url: `/auth/otp/verify`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: otpVerifyRequest, signal
    },
      );
    }
  


export const getAuthControllerVerifyOtpMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authControllerVerifyOtp>>, TError,{data: OtpVerifyRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof authControllerVerifyOtp>>, TError,{data: OtpVerifyRequest}, TContext> => {

const mutationKey = ['authControllerVerifyOtp'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof authControllerVerifyOtp>>, {data: OtpVerifyRequest}> = (props) => {
          const {data} = props ?? {};

          return  authControllerVerifyOtp(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AuthControllerVerifyOtpMutationResult = NonNullable<Awaited<ReturnType<typeof authControllerVerifyOtp>>>
    export type AuthControllerVerifyOtpMutationBody = OtpVerifyRequest
    export type AuthControllerVerifyOtpMutationError = void

    /**
 * @summary Verify the 5-digit OTP. Marks the row verified; signup must run within 10 minutes.
 */
export const useAuthControllerVerifyOtp = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authControllerVerifyOtp>>, TError,{data: OtpVerifyRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof authControllerVerifyOtp>>,
        TError,
        {data: OtpVerifyRequest},
        TContext
      > => {

      const mutationOptions = getAuthControllerVerifyOtpMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary G1 self-signup. Requires a verified+unconsumed OTP for the phone within 10 minutes and a current consent_version_id.
 */
export const authControllerSignup = (
    signupRequest: SignupRequest,
 signal?: AbortSignal
) => {
      
      
      return fseAxios<AuthTokens>(
      {url: `/auth/signup`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: signupRequest, signal
    },
      );
    }
  


export const getAuthControllerSignupMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authControllerSignup>>, TError,{data: SignupRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof authControllerSignup>>, TError,{data: SignupRequest}, TContext> => {

const mutationKey = ['authControllerSignup'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof authControllerSignup>>, {data: SignupRequest}> = (props) => {
          const {data} = props ?? {};

          return  authControllerSignup(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AuthControllerSignupMutationResult = NonNullable<Awaited<ReturnType<typeof authControllerSignup>>>
    export type AuthControllerSignupMutationBody = SignupRequest
    export type AuthControllerSignupMutationError = void

    /**
 * @summary G1 self-signup. Requires a verified+unconsumed OTP for the phone within 10 minutes and a current consent_version_id.
 */
export const useAuthControllerSignup = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authControllerSignup>>, TError,{data: SignupRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof authControllerSignup>>,
        TError,
        {data: SignupRequest},
        TContext
      > => {

      const mutationOptions = getAuthControllerSignupMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Claim a coop-registered account. Requires a verified+unconsumed `claim` OTP for the phone within 10 minutes; sets the PIN on the existing pin-less user and mints tokens.
 */
export const authControllerClaim = (
    claimRequest: ClaimRequest,
 signal?: AbortSignal
) => {
      
      
      return fseAxios<AuthTokens>(
      {url: `/auth/claim`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: claimRequest, signal
    },
      );
    }
  


export const getAuthControllerClaimMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authControllerClaim>>, TError,{data: ClaimRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof authControllerClaim>>, TError,{data: ClaimRequest}, TContext> => {

const mutationKey = ['authControllerClaim'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof authControllerClaim>>, {data: ClaimRequest}> = (props) => {
          const {data} = props ?? {};

          return  authControllerClaim(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AuthControllerClaimMutationResult = NonNullable<Awaited<ReturnType<typeof authControllerClaim>>>
    export type AuthControllerClaimMutationBody = ClaimRequest
    export type AuthControllerClaimMutationError = void

    /**
 * @summary Claim a coop-registered account. Requires a verified+unconsumed `claim` OTP for the phone within 10 minutes; sets the PIN on the existing pin-less user and mints tokens.
 */
export const useAuthControllerClaim = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authControllerClaim>>, TError,{data: ClaimRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof authControllerClaim>>,
        TError,
        {data: ClaimRequest},
        TContext
      > => {

      const mutationOptions = getAuthControllerClaimMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Reset the PIN on an existing account. Requires a verified+unconsumed `pin_reset` OTP for the phone within 10 minutes; replaces the existing PIN, clears any lockout, and mints tokens.
 */
export const authControllerResetPin = (
    resetPinRequest: ResetPinRequest,
 signal?: AbortSignal
) => {
      
      
      return fseAxios<AuthTokens>(
      {url: `/auth/reset-pin`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: resetPinRequest, signal
    },
      );
    }
  


export const getAuthControllerResetPinMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authControllerResetPin>>, TError,{data: ResetPinRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof authControllerResetPin>>, TError,{data: ResetPinRequest}, TContext> => {

const mutationKey = ['authControllerResetPin'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof authControllerResetPin>>, {data: ResetPinRequest}> = (props) => {
          const {data} = props ?? {};

          return  authControllerResetPin(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AuthControllerResetPinMutationResult = NonNullable<Awaited<ReturnType<typeof authControllerResetPin>>>
    export type AuthControllerResetPinMutationBody = ResetPinRequest
    export type AuthControllerResetPinMutationError = void

    /**
 * @summary Reset the PIN on an existing account. Requires a verified+unconsumed `pin_reset` OTP for the phone within 10 minutes; replaces the existing PIN, clears any lockout, and mints tokens.
 */
export const useAuthControllerResetPin = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authControllerResetPin>>, TError,{data: ResetPinRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof authControllerResetPin>>,
        TError,
        {data: ResetPinRequest},
        TContext
      > => {

      const mutationOptions = getAuthControllerResetPinMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    